// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"Svg\"].freehand {\n    cursor: crosshair;\n  }\n  [name=\"Svg\"].dragging, [name=\"Svg\"].dragging circle, [name=\"Svg\"].dragging rect {\n    cursor: -webkit-grabbing;\n    cursor: grabbing;\n  }\n", ""]);
// Exports
module.exports = exports;
